/**
 * Couleur d'un calendrier (planning) pour l'UI.
 *
 * On privilégie la couleur définie en base (`gym_calendars.color`). Si elle est
 * absente ou invalide, on retombe sur une palette franche et distincte, choisie
 * de façon DÉTERMINISTE à partir d'une graine (l'identifiant du calendrier) :
 * le même planning garde donc toujours la même couleur d'un écran à l'autre.
 */

export const CALENDAR_FALLBACK_PALETTE = [
  '#6366f1', // indigo
  '#ec4899', // rose
  '#14b8a6', // teal
  '#f59e0b', // amber
  '#8b5cf6', // violet
  '#ef4444', // red
  '#0ea5e9', // sky
  '#84cc16', // lime
];

const HEX_RE = /^#([0-9a-f]{3}|[0-9a-f]{6})$/i;

export function resolveCalendarColor(color?: string | null, seed?: string | null): string {
  const c = (color ?? '').trim();
  if (HEX_RE.test(c)) return c;
  let h = 0;
  for (const ch of seed ?? '') h = (h * 31 + ch.charCodeAt(0)) >>> 0;
  return CALENDAR_FALLBACK_PALETTE[h % CALENDAR_FALLBACK_PALETTE.length];
}

/** Texte lisible (quasi-noir ou blanc) au-dessus d'une couleur de fond donnée. */
export function readableTextColor(hex: string): string {
  let h = hex.replace('#', '');
  if (h.length === 3) h = h.split('').map((x) => x + x).join('');
  const r = parseInt(h.slice(0, 2), 16);
  const g = parseInt(h.slice(2, 4), 16);
  const b = parseInt(h.slice(4, 6), 16);
  const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
  return luminance > 0.62 ? '#111827' : '#ffffff';
}

/** Version très pâle d'une couleur, pour un fond de badge (canal alpha en hex). */
export function softCalendarBg(hex: string, alpha = 0.14): string {
  const a = Math.round(Math.min(1, Math.max(0, alpha)) * 255)
    .toString(16)
    .padStart(2, '0');
  let h = hex.replace('#', '');
  if (h.length === 3) h = h.split('').map((x) => x + x).join('');
  return `#${h}${a}`;
}
